import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../hooks/useEmployee";
import useEmailMaster from "../../../hooks/useEmailMaster";
import useBranch from "../../../hooks/useBranch";

import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue, formatDate } from "../../../utils/common";
import { OperatorConstants } from "../../../constants/operator.constants";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const initialValues = {
    startTimeOperator: "btn",
    startTime: [new Date(), new Date()],
    startTimeStr: formatDate(new Date()) + " 00:00:00," + formatDate(new Date()) + " 23:59:59",
    endTimeOperator: "btn",
    endTime: [new Date(), new Date()],
    endTimeStr: formatDate(new Date()) + " 00:00:00," + formatDate(new Date()) + " 23:59:59",
  };

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      let newFilters = [];

      if (data.startTime != "" && data.startTime != null) {
        console.log(data.startTimeStr, "data.startTimeStr");
        newFilters.push({
          fieldName: "startTime",
          fieldValue: data.startTimeStr,
          op: data.startTimeOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.endTime != "" && data.endTime != null) {
        console.log(data.endTimeStr, "data.startTimeStr");
        newFilters.push({
          fieldName: "endTime",
          fieldValue: data.endTimeStr,
          op: data.endTimeOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload((prev) => {
        const existingFilters = prev.filters || [];

        //Update existing filters
        const updatedFilters = existingFilters.map((f) => {
          const updated = newFilters.find((nf) => nf.fieldName === f.fieldName);

          return updated ? { ...f, ...updated } : f;
        });

        //Add filters that do NOT exist yet
        const filtersToAdd = newFilters.filter(
          (nf) => !existingFilters.some((f) => f.fieldName === nf.fieldName),
        );

        return {
          ...prev,
          filters: [...updatedFilters, ...filtersToAdd],
        };
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="startTimeOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              >
                {Object.entries(OperatorConstants.date).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <CustomDatePicker
                name="startTime"
                nameTemp="startTimeStr"
                label="Start Time "
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="endTimeOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              >
                {Object.entries(OperatorConstants.date).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <CustomDatePicker
                name="endTime"
                nameTemp="endTimeStr"
                label="End Time "
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
